import { Controller } from "@hotwired/stimulus"

// URL から HTML フラグメントを fetch して <dialog> に差し込む汎用モーダル。
// 一覧の各行にダイアログを複製せず、 ページに 1 つ置いた dialog を使い回す。
//
// 使い方:
//   %div{data: { controller: "remote-modal" }}
//     %button{data: { action: "click->remote-modal#open", remote_modal_url: "...", remote_modal_title: "..." }}
//     %dialog{data: { remote_modal_target: "dialog" }}
//       %h3{data: { remote_modal_target: "title" }}
//       %div{data: { remote_modal_target: "content" }}
export default class extends Controller {
  static targets = ["dialog", "content", "title"]

  connect() {
    this.dialogTarget.addEventListener("click", (e) => {
      if (e.target === this.dialogTarget) this.close()
    })

    // Turbo キャッシュ復元時にダイアログを閉じる
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  async open(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.remoteModalUrl
    if (!url) return

    const title = event.currentTarget.dataset.remoteModalTitle
    if (title && this.hasTitleTarget) this.titleTarget.textContent = title

    this.contentTarget.innerHTML = '<div class="flex justify-center py-12"><div class="bounce-loader"><div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div></div></div>'
    this.dialogTarget.showModal()

    const response = await fetch(url, { headers: { "Accept": "text/html" } })
    if (!response.ok) {
      this.contentTarget.innerHTML = '<p class="py-12 text-center text-sm text-red-600">読み込みに失敗しました</p>'
      return
    }
    this.contentTarget.innerHTML = await response.text()
  }

  close() {
    this.dialogTarget.close()
    this.contentTarget.innerHTML = ""
  }
}
